exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/cauth/cauth.component.scss
// module id = ../../../../../src/app/cauth/cauth.component.scss
// module chunks = main